(function($) {

$.fn.swiperSimple = function(settings, element) {
    var defaultSettings = {
        mobileMin: 16,
        tabletMax: 16,
        desktopMin: 32,
        desktopMax: 32,
        navigation: {
            nextEl: '.js-swiper-next',
            prevEl: '.js-swiper-prev',
        },
    };
    var config = $.extend({}, defaultSettings, settings);
    var init = function () {
        var swiper = new Swiper (element, {
            navigation: config.navigation,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
            breakpoints: {
                360: {
                    spaceBetween: config.mobileMin
                },
                1024: {
                    spaceBetween: config.tabletMax
                },
                1280: {
                    spaceBetween: config.desktopMin
                },
                1920: {
                    spaceBetween: config.desktopMax
                },
            }
        });

        return swiper;
    };

    return init();
};
})(jQuery);
